import React, { useState, useEffect } from "react";
import { X, Mail, AlertCircle, CheckCircle, ChevronDown } from "lucide-react";
import { LEAD_CHANNELS } from "../../constants/data";
import { saveLeadToAPI } from "../../services/api";

const GOLD = "#50C878";

// ─── ALL COUNTRY CODES ───────────────────────────────────────
const COUNTRY_CODES = [
  { code: "+91",  flag: "🇮🇳", name: "India" },
  { code: "+1",   flag: "🇺🇸", name: "USA / Canada" },
  { code: "+44",  flag: "🇬🇧", name: "United Kingdom" },
  { code: "+971", flag: "🇦🇪", name: "UAE" },
  { code: "+966", flag: "🇸🇦", name: "Saudi Arabia" },
  { code: "+965", flag: "🇰🇼", name: "Kuwait" },
  { code: "+974", flag: "🇶🇦", name: "Qatar" },
  { code: "+973", flag: "🇧🇭", name: "Bahrain" },
  { code: "+968", flag: "🇴🇲", name: "Oman" },
  { code: "+65",  flag: "🇸🇬", name: "Singapore" },
  { code: "+60",  flag: "🇲🇾", name: "Malaysia" },
  { code: "+61",  flag: "🇦🇺", name: "Australia" },
  { code: "+64",  flag: "🇳🇿", name: "New Zealand" },
  { code: "+49",  flag: "🇩🇪", name: "Germany" },
  { code: "+33",  flag: "🇫🇷", name: "France" },
  { code: "+39",  flag: "🇮🇹", name: "Italy" },
  { code: "+34",  flag: "🇪🇸", name: "Spain" },
  { code: "+31",  flag: "🇳🇱", name: "Netherlands" },
  { code: "+32",  flag: "🇧🇪", name: "Belgium" },
  { code: "+41",  flag: "🇨🇭", name: "Switzerland" },
  { code: "+43",  flag: "🇦🇹", name: "Austria" },
  { code: "+46",  flag: "🇸🇪", name: "Sweden" },
  { code: "+47",  flag: "🇳🇴", name: "Norway" },
  { code: "+45",  flag: "🇩🇰", name: "Denmark" },
  { code: "+358", flag: "🇫🇮", name: "Finland" },
  { code: "+351", flag: "🇵🇹", name: "Portugal" },
  { code: "+30",  flag: "🇬🇷", name: "Greece" },
  { code: "+48",  flag: "🇵🇱", name: "Poland" },
  { code: "+420", flag: "🇨🇿", name: "Czech Republic" },
  { code: "+36",  flag: "🇭🇺", name: "Hungary" },
  { code: "+40",  flag: "🇷🇴", name: "Romania" },
  { code: "+359", flag: "🇧🇬", name: "Bulgaria" },
  { code: "+385", flag: "🇭🇷", name: "Croatia" },
  { code: "+386", flag: "🇸🇮", name: "Slovenia" },
  { code: "+421", flag: "🇸🇰", name: "Slovakia" },
  { code: "+370", flag: "🇱🇹", name: "Lithuania" },
  { code: "+371", flag: "🇱🇻", name: "Latvia" },
  { code: "+372", flag: "🇪🇪", name: "Estonia" },
  { code: "+7",   flag: "🇷🇺", name: "Russia" },
  { code: "+380", flag: "🇺🇦", name: "Ukraine" },
  { code: "+375", flag: "🇧🇾", name: "Belarus" },
  { code: "+90",  flag: "🇹🇷", name: "Turkey" },
  { code: "+972", flag: "🇮🇱", name: "Israel" },
  { code: "+20",  flag: "🇪🇬", name: "Egypt" },
  { code: "+212", flag: "🇲🇦", name: "Morocco" },
  { code: "+216", flag: "🇹🇳", name: "Tunisia" },
  { code: "+213", flag: "🇩🇿", name: "Algeria" },
  { code: "+27",  flag: "🇿🇦", name: "South Africa" },
  { code: "+234", flag: "🇳🇬", name: "Nigeria" },
  { code: "+254", flag: "🇰🇪", name: "Kenya" },
  { code: "+233", flag: "🇬🇭", name: "Ghana" },
  { code: "+251", flag: "🇪🇹", name: "Ethiopia" },
  { code: "+255", flag: "🇹🇿", name: "Tanzania" },
  { code: "+256", flag: "🇺🇬", name: "Uganda" },
  { code: "+86",  flag: "🇨🇳", name: "China" },
  { code: "+81",  flag: "🇯🇵", name: "Japan" },
  { code: "+82",  flag: "🇰🇷", name: "South Korea" },
  { code: "+63",  flag: "🇵🇭", name: "Philippines" },
  { code: "+62",  flag: "🇮🇩", name: "Indonesia" },
  { code: "+66",  flag: "🇹🇭", name: "Thailand" },
  { code: "+84",  flag: "🇻🇳", name: "Vietnam" },
  { code: "+880", flag: "🇧🇩", name: "Bangladesh" },
  { code: "+94",  flag: "🇱🇰", name: "Sri Lanka" },
  { code: "+92",  flag: "🇵🇰", name: "Pakistan" },
  { code: "+977", flag: "🇳🇵", name: "Nepal" },
  { code: "+95",  flag: "🇲🇲", name: "Myanmar" },
  { code: "+855", flag: "🇰🇭", name: "Cambodia" },
  { code: "+856", flag: "🇱🇦", name: "Laos" },
  { code: "+673", flag: "🇧🇳", name: "Brunei" },
  { code: "+960", flag: "🇲🇻", name: "Maldives" },
  { code: "+975", flag: "🇧🇹", name: "Bhutan" },
  { code: "+98",  flag: "🇮🇷", name: "Iran" },
  { code: "+964", flag: "🇮🇶", name: "Iraq" },
  { code: "+963", flag: "🇸🇾", name: "Syria" },
  { code: "+962", flag: "🇯🇴", name: "Jordan" },
  { code: "+961", flag: "🇱🇧", name: "Lebanon" },
  { code: "+970", flag: "🇵🇸", name: "Palestine" },
  { code: "+967", flag: "🇾🇪", name: "Yemen" },
  { code: "+93",  flag: "🇦🇫", name: "Afghanistan" },
  { code: "+996", flag: "🇰🇬", name: "Kyrgyzstan" },
  { code: "+992", flag: "🇹🇯", name: "Tajikistan" },
  { code: "+993", flag: "🇹🇲", name: "Turkmenistan" },
  { code: "+998", flag: "🇺🇿", name: "Uzbekistan" },
  { code: "+7",   flag: "🇰🇿", name: "Kazakhstan" },
  { code: "+994", flag: "🇦🇿", name: "Azerbaijan" },
  { code: "+374", flag: "🇦🇲", name: "Armenia" },
  { code: "+995", flag: "🇬🇪", name: "Georgia" },
  { code: "+52",  flag: "🇲🇽", name: "Mexico" },
  { code: "+55",  flag: "🇧🇷", name: "Brazil" },
  { code: "+54",  flag: "🇦🇷", name: "Argentina" },
  { code: "+57",  flag: "🇨🇴", name: "Colombia" },
  { code: "+56",  flag: "🇨🇱", name: "Chile" },
  { code: "+51",  flag: "🇵🇪", name: "Peru" },
  { code: "+58",  flag: "🇻🇪", name: "Venezuela" },
  { code: "+593", flag: "🇪🇨", name: "Ecuador" },
  { code: "+591", flag: "🇧🇴", name: "Bolivia" },
  { code: "+595", flag: "🇵🇾", name: "Paraguay" },
  { code: "+598", flag: "🇺🇾", name: "Uruguay" },
  { code: "+506", flag: "🇨🇷", name: "Costa Rica" },
  { code: "+507", flag: "🇵🇦", name: "Panama" },
  { code: "+502", flag: "🇬🇹", name: "Guatemala" },
  { code: "+503", flag: "🇸🇻", name: "El Salvador" },
  { code: "+504", flag: "🇭🇳", name: "Honduras" },
  { code: "+505", flag: "🇳🇮", name: "Nicaragua" },
  { code: "+53",  flag: "🇨🇺", name: "Cuba" },
  { code: "+1876",flag: "🇯🇲", name: "Jamaica" },
  { code: "+1868",flag: "🇹🇹", name: "Trinidad & Tobago" },
  { code: "+509", flag: "🇭🇹", name: "Haiti" },
  { code: "+53",  flag: "🇩🇴", name: "Dominican Republic" },
];

export default function LeadCaptureModal({
  isOpen, onClose,
  propertyTitle, propertyId,
  channel = LEAD_CHANNELS.WEB,
  onSuccess,
  propertyImages = [],
  prefillMessage = "",
}) {
  const [form, setForm] = useState({
    firstName: "", lastName: "", phone: "", email: "", message: "",
    countryCode: "+91", phoneType: "mobile", stdCode: "",
  });
  const [errors, setErrors]   = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [codeSearch, setCodeSearch] = useState("");

  useEffect(() => {
    if (isOpen) {
      setForm({ firstName: "", lastName: "", phone: "", email: "", message: prefillMessage || "", countryCode: "+91", phoneType: "mobile", stdCode: "" });
      setErrors({});
      setSubmitted(false);
      setCodeSearch("");
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [isOpen, prefillMessage]);

  if (!isOpen) return null;

  const filteredCodes = codeSearch
    ? COUNTRY_CODES.filter(c => c.name.toLowerCase().includes(codeSearch.toLowerCase()) || c.code.includes(codeSearch))
    : COUNTRY_CODES;

  function validate() {
    const e = {};
    if (!form.firstName.trim()) e.firstName = "First name is required";
    if (!form.phone.trim()) {
      e.phone = "Phone number is required";
    } else {
      const num = form.phone.replace(/\s/g, "");
      if (form.countryCode === "+91") {
        if (form.phoneType === "mobile" && !/^[6-9]\d{9}$/.test(num))
          e.phone = "Enter a valid 10-digit Indian mobile number";
        else if (form.phoneType === "landline" && !/^\d{6,11}$/.test(num))
          e.phone = "Enter a valid landline number (6–11 digits)";
      } else if (!/^\d{4,15}$/.test(num)) {
        e.phone = "Enter a valid phone number";
      }
    }
    if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
      e.email = "Enter a valid email address";
    return e;
  }

  async function handleSubmit() {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }
    setLoading(true);
    try {
      const stdPrefix = form.phoneType === "landline" && form.stdCode ? form.stdCode.trim() : "";
      const rawPhone  = form.phone.replace(/\s/g, "");
      const fullPhone = `${form.countryCode}${stdPrefix}${rawPhone}`;

      const lead = await saveLeadToAPI({
        first_name:     form.firstName.trim(),
        last_name:      form.lastName.trim(),
        phone:          fullPhone,
        email:          form.email.trim(),
        message:        form.message.trim(),
        property_title: propertyTitle || null,
        property_id:    propertyId    || null,
        channel,
        notes: `Phone type: ${form.phoneType}`,
      });
      setSubmitted(true);
      if (onSuccess) onSuccess(lead);
      setTimeout(onClose, 4500);
    } catch {
      setErrors({ submit: "Something went wrong. Please try again." });
    } finally {
      setLoading(false);
    }
  }

  const selectedCountry = COUNTRY_CODES.find(c => c.code === form.countryCode) || COUNTRY_CODES[0];

  const inp = (field) => ({
    width: "100%", padding: "11px 14px",
    background: "rgba(80,200,120,0.10)",
    border: `1.5px solid ${errors[field] ? "#e05a5a" : "rgba(80,200,120,0.3)"}`,
    borderRadius: "6px", color: "#013220",
    fontFamily: "'Inter', sans-serif", fontSize: "0.92rem",
    outline: "none", boxSizing: "border-box", transition: "border-color 0.2s",
  });

  return (
    <div
      onClick={onClose}
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.82)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", padding: "16px", backdropFilter: "blur(4px)" }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ background: "linear-gradient(135deg, #FFFFFF, #F7FBF8)", border: "1px solid rgba(80,200,120,0.35)", borderRadius: "16px", width: "100%", maxWidth: "500px", maxHeight: "92vh", overflowY: "auto", position: "relative", boxShadow: "0 25px 60px rgba(0,0,0,0.85)" }}
      >
        {/* Sticky close */}
        <div style={{ position: "sticky", top: 0, zIndex: 10, display: "flex", justifyContent: "flex-end", padding: "12px 14px 0", background: "linear-gradient(#FFFFFF, transparent)" }}>
          <button onClick={onClose} style={{ background: "rgba(80,200,120,0.10)", border: "none", borderRadius: "50%", width: "30px", height: "30px", cursor: "pointer", color: "rgba(1,50,32,0.55)", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <X size={15} />
          </button>
        </div>

        <div style={{ padding: "4px 28px 32px" }}>

          {submitted ? (
            /* ── SUCCESS ── */
            <div>
              <div style={{ textAlign: "center", marginBottom: "20px" }}>
                <CheckCircle size={52} color={GOLD} style={{ marginBottom: "12px" }} />
                <h3 style={{ color: "#013220", fontFamily: "'Cormorant Garamond', serif", fontSize: "1.6rem", margin: "0 0 8px" }}>
                  Thank You, {form.firstName}!
                </h3>
                <p style={{ color: "rgba(1,50,32,0.85)", lineHeight: 1.6, fontFamily: "'Inter', sans-serif", fontSize: "0.9rem" }}>
                  Our associate will contact you on{" "}
                  <strong style={{ color: GOLD }}>{form.countryCode} {form.stdCode}{form.phone}</strong> shortly.
                </p>
              </div>

              {propertyImages.length > 0 && (
                <div>
                  <p style={{ color: "rgba(1,50,32,0.62)", fontSize: "0.72rem", fontFamily: "'Inter', sans-serif", textAlign: "center", marginBottom: "10px", letterSpacing: "0.1em", textTransform: "uppercase" }}>
                    {propertyTitle || "Your Selected Property"}
                  </p>
                  <div style={{ display: "grid", gridTemplateColumns: `repeat(${Math.min(propertyImages.length, 3)}, 1fr)`, gap: "5px", borderRadius: "8px", overflow: "hidden" }}>
                    {propertyImages.slice(0, 3).map((src, i) => (
                      <img key={i} src={src} alt="" style={{ width: "100%", aspectRatio: "4/3", objectFit: "cover", display: "block" }} />
                    ))}
                  </div>
                  <p style={{ color: "rgba(1,50,32,0.48)", fontSize: "0.75rem", fontFamily: "'Inter', sans-serif", textAlign: "center", marginTop: "12px" }}>
                    This window closes automatically
                  </p>
                </div>
              )}
            </div>
          ) : (
            /* ── FORM ── */
            <>
              <div style={{ marginBottom: "18px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "4px" }}>
                  <div style={{ width: "28px", height: "2px", background: GOLD }} />
                  <span style={{ color: GOLD, fontFamily: "'Inter', sans-serif", fontSize: "0.72rem", letterSpacing: "0.15em", textTransform: "uppercase" }}>
                    Express Your Interest
                  </span>
                </div>
                <h2 style={{ color: "#013220", fontFamily: "'Cormorant Garamond', serif", fontSize: "1.65rem", fontWeight: 600, lineHeight: 1.2, margin: "6px 0 4px" }}>
                  {propertyTitle ? `Register for ${propertyTitle}` : "Let's Talk"}
                </h2>
                <p style={{ color: "rgba(1,50,32,0.62)", fontSize: "0.85rem", fontFamily: "'Inter', sans-serif" }}>
                  Our associate will call within 24 hours.
                </p>
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: "13px" }}>

                {/* Name */}
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                  <div>
                    <label style={{ display: "block", color: "rgba(1,50,32,0.62)", fontSize: "0.78rem", marginBottom: "5px", fontFamily: "'Inter',sans-serif" }}>
                      First Name <span style={{ color: GOLD }}>*</span>
                    </label>
                    <input
                      // placeholder="Rajesh"
                      value={form.firstName}
                      onChange={(e) => setForm({ ...form, firstName: e.target.value })}
                      style={inp("firstName")}
                      onFocus={(e) => (e.target.style.borderColor = GOLD)}
                      onBlur={(e)  => (e.target.style.borderColor = errors.firstName ? "#e05a5a" : "rgba(80,200,120,0.3)")}
                    />
                    {errors.firstName && (
                      <p style={{ color: "#e05a5a", fontSize: "0.72rem", marginTop: "3px", display: "flex", alignItems: "center", gap: "3px", fontFamily: "'Inter',sans-serif" }}>
                        <AlertCircle size={11} /> {errors.firstName}
                      </p>
                    )}
                  </div>
                  <div>
                    <label style={{ display: "block", color: "rgba(1,50,32,0.62)", fontSize: "0.78rem", marginBottom: "5px", fontFamily: "'Inter',sans-serif" }}>
                      Last Name
                    </label>
                    <input
                      // placeholder="Kumar"
                      value={form.lastName}
                      onChange={(e) => setForm({ ...form, lastName: e.target.value })}
                      style={inp("lastName")}
                      onFocus={(e) => (e.target.style.borderColor = GOLD)}
                      onBlur={(e)  => (e.target.style.borderColor = "rgba(80,200,120,0.3)")}
                    />
                  </div>
                </div>

                {/* Phone */}
                <div>
                  <label style={{ display: "block", color: "rgba(1,50,32,0.62)", fontSize: "0.78rem", marginBottom: "5px", fontFamily: "'Inter',sans-serif" }}>
                    Phone Number <span style={{ color: GOLD }}>*</span>
                  </label>

                  {/* Mobile / Landline toggle */}
                  <div style={{ display: "flex", gap: "6px", marginBottom: "8px" }}>
                    {["mobile", "landline"].map((t) => (
                      <button
                        key={t}
                        onClick={() => setForm({ ...form, phoneType: t, phone: "", stdCode: "" })}
                        style={{ padding: "5px 14px", borderRadius: "20px", border: `1px solid ${form.phoneType === t ? GOLD : "rgba(80,200,120,0.10)"}`, background: form.phoneType === t ? "rgba(80,200,120,0.12)" : "transparent", color: form.phoneType === t ? GOLD : "rgba(1,50,32,0.62)", fontFamily: "'Inter',sans-serif", fontSize: "0.78rem", fontWeight: form.phoneType === t ? 600 : 400, cursor: "pointer" }}
                      >
                        {t === "mobile" ? "📱 Mobile" : "☎️ Landline"}
                      </button>
                    ))}
                  </div>

                  {/* Country code selector + number */}
                  <div style={{ display: "flex", gap: "8px" }}>
                    {/* Country code dropdown */}
                    <div style={{ position: "relative", flexShrink: 0 }}>
                      <select
                        value={form.countryCode}
                        onChange={(e) => setForm({ ...form, countryCode: e.target.value })}
                        style={{ padding: "11px 28px 11px 10px", background: "rgba(80,200,120,0.10)", border: "1.5px solid rgba(80,200,120,0.3)", borderRadius: "6px", color: "#013220", fontFamily: "'Inter',sans-serif", fontSize: "0.85rem", outline: "none", cursor: "pointer", appearance: "none", WebkitAppearance: "none", minWidth: "100px" }}
                        onFocus={(e) => (e.target.style.borderColor = GOLD)}
                        onBlur={(e)  => (e.target.style.borderColor = "rgba(80,200,120,0.3)")}
                      >
                        {COUNTRY_CODES.map((c, i) => (
                          <option key={`${c.code}-${i}`} value={c.code} style={{ background: "#FFFFFF", color: "#013220" }}>
                            {c.flag} {c.code} {c.name}
                          </option>
                        ))}
                      </select>
                      <ChevronDown size={13} style={{ position: "absolute", right: "7px", top: "50%", transform: "translateY(-50%)", color: "rgba(1,50,32,0.62)", pointerEvents: "none" }} />
                    </div>

                    {/* Number input(s) */}
                    {form.phoneType === "landline" ? (
                      <div style={{ display: "flex", gap: "6px", flex: 1 }}>
                        <input
                          placeholder="STD (040)"
                          value={form.stdCode}
                          onChange={(e) => setForm({ ...form, stdCode: e.target.value })}
                          style={{ ...inp("phone"), width: "90px", flexShrink: 0 }}
                          onFocus={(e) => (e.target.style.borderColor = GOLD)}
                          onBlur={(e)  => (e.target.style.borderColor = "rgba(80,200,120,0.3)")}
                        />
                        <input
                          placeholder="Number"
                          value={form.phone}
                          onChange={(e) => setForm({ ...form, phone: e.target.value })}
                          type="tel"
                          style={{ ...inp("phone"), flex: 1 }}
                          onFocus={(e) => (e.target.style.borderColor = GOLD)}
                          onBlur={(e)  => (e.target.style.borderColor = errors.phone ? "#e05a5a" : "rgba(80,200,120,0.3)")}
                        />
                      </div>
                    ) : (
                      <input
                        // placeholder={form.countryCode === "+91" ? "9876543210" : "Phone number"}
                        value={form.phone}
                        onChange={(e) => setForm({ ...form, phone: e.target.value })}
                        type="tel"
                        style={{ ...inp("phone"), flex: 1 }}
                        onFocus={(e) => (e.target.style.borderColor = GOLD)}
                        onBlur={(e)  => (e.target.style.borderColor = errors.phone ? "#e05a5a" : "rgba(80,200,120,0.3)")}
                      />
                    )}
                  </div>

                  {errors.phone && (
                    <p style={{ color: "#e05a5a", fontSize: "0.72rem", marginTop: "3px", display: "flex", alignItems: "center", gap: "3px", fontFamily: "'Inter',sans-serif" }}>
                      <AlertCircle size={11} /> {errors.phone}
                    </p>
                  )}
                  {form.phoneType === "landline" && (
                    <p style={{ color: "rgba(1,50,32,0.48)", fontSize: "0.71rem", marginTop: "3px", fontFamily: "'Inter',sans-serif" }}>
                      e.g. STD: 040  Number: 23456789
                    </p>
                  )}
                </div>

                {/* Email */}
                <div>
                  <label style={{ display: "block", color: "rgba(1,50,32,0.62)", fontSize: "0.78rem", marginBottom: "5px", fontFamily: "'Inter',sans-serif" }}>
                    Email Address
                  </label>
                  <div style={{ position: "relative" }}>
                    <Mail size={14} style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: "rgba(1,50,32,0.48)", pointerEvents: "none" }} />
                    <input
                      // type="email" placeholder="rajesh@email.com"
                      value={form.email}
                      onChange={(e) => setForm({ ...form, email: e.target.value })}
                      style={{ ...inp("email"), paddingLeft: "36px" }}
                      onFocus={(e) => (e.target.style.borderColor = GOLD)}
                      onBlur={(e)  => (e.target.style.borderColor = errors.email ? "#e05a5a" : "rgba(80,200,120,0.3)")}
                    />
                  </div>
                  {errors.email && (
                    <p style={{ color: "#e05a5a", fontSize: "0.72rem", marginTop: "3px", display: "flex", alignItems: "center", gap: "3px", fontFamily: "'Inter',sans-serif" }}>
                      <AlertCircle size={11} /> {errors.email}
                    </p>
                  )}
                </div>

                {/* Message */}
                <div>
                  <label style={{ display: "block", color: "rgba(1,50,32,0.62)", fontSize: "0.78rem", marginBottom: "5px", fontFamily: "'Inter',sans-serif" }}>
                    Message (optional)
                  </label>
                  <textarea
                    placeholder="Any specific requirements or questions..."
                    value={form.message}
                    onChange={(e) => setForm({ ...form, message: e.target.value })}
                    rows={3}
                    style={{ ...inp("message"), resize: "vertical", lineHeight: 1.5 }}
                    onFocus={(e) => (e.target.style.borderColor = GOLD)}
                    onBlur={(e)  => (e.target.style.borderColor = "rgba(80,200,120,0.3)")}
                  />
                </div>

                {errors.submit && (
                  <p style={{ color: "#e05a5a", fontSize: "0.82rem", display: "flex", alignItems: "center", gap: "5px", fontFamily: "'Inter',sans-serif" }}>
                    <AlertCircle size={13} /> {errors.submit}
                  </p>
                )}

                <button
                  onClick={handleSubmit}
                  disabled={loading}
                  style={{ width: "100%", padding: "14px", background: loading ? "rgba(80,200,120,0.5)" : "linear-gradient(135deg, #50C878, #7FD9A0)", border: "none", borderRadius: "6px", color: "#FFFFFF", fontFamily: "'Inter',sans-serif", fontWeight: 700, fontSize: "0.95rem", cursor: loading ? "not-allowed" : "pointer", letterSpacing: "0.03em", transition: "opacity 0.2s" }}
                  onMouseOver={(e) => { if (!loading) e.currentTarget.style.opacity = "0.88"; }}
                  onMouseOut={(e)  => { e.currentTarget.style.opacity = "1"; }}
                >
                  {loading ? "Submitting…" : "Submit — Connect Me with an Associate"}
                </button>

                <p style={{ textAlign: "center", color: "rgba(1,50,32,0.48)", fontSize: "0.72rem", fontFamily: "'Inter',sans-serif" }}>
                  We never share your details with third parties.
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
